import React, { useState, useEffect } from 'react'
import { withStyles, Typography, Collapse } from '@material-ui/core';
import PropTypes from 'prop-types';
import GridBlock from 'components/GridBlock';
import Checkbox from 'components/Checkbox';
import clsx from 'clsx';
import RawHTML from 'components/RawHTML';
import WorkableIconExpandButton from "components/button/WorkableIconExpandButton";

const style = theme => ({
	root: {
	},
	radioGroup: {
		width: '100%',
		margin: 0,
	},
	rotate: {
		transform: 'rotate(180deg)'
	},
	margin: {
		marginLeft: theme.spacing(2),
	},
	filteredItemRoot: {
		display: 'flex',
		width: '100%',
		alignItems: 'center'
	}
})

function ListElement({
	classes,
	className,
	formikProps,
	itemValue,
	searchKeys,
	 multiple,
	 handleSave
}) {

	const {
		identity,
		publicCode,
		name,
		children,
		shouldOpen = false,
		...otherItemValues
	} = itemValue;

	const [boldLabel, setBoldLabel] = useState('')
	const [open, setOpen] = useState(shouldOpen)

	useEffect(() => {
		setOpen(shouldOpen)
	}, [shouldOpen])


	const handleArrowClick = () => {
		setOpen(!open)
	}

	const checkboxId = JSON.stringify({
		identity,
		publicCode,
		name,
		...otherItemValues
	})

	const _label = `${publicCode} ${name}`;

	useEffect(() => {
		let label = _label;
		searchKeys.forEach(key => {
			if (key === '') return;
			const reg = new RegExp(`(${key})`, 'ig')
			label = label.replace(reg, `<b>$1</b>`);
		});
		setBoldLabel(label)
	}, [searchKeys, _label])

	const openRow = open;

	const label = (
		<RawHTML type={Typography} props={{ variant: 'body1' }}>
			{boldLabel}
		</RawHTML>
	)

	// const checkbox = (id) => {
	// 	const value = getObjectValue(id, formikProps.values, false);
	// 	return (
	// 		<input
	// 			type='checkbox'
	// 			name={id}
	// 			onChange={formikProps.handleChange}
	// 			onBlur={formikProps.handleBlur}
	// 			checked={value}
	// 		/>
	// 	)
	// }

	const renderChildren = () => {
		return children.map((item, i) => {
			return (
				<ListElement
					searchKeys={searchKeys}
					itemValue={item}
					formikProps={formikProps}
					classes={classes}
					key={i}
					handleSave={handleSave}
					multiple={multiple}
				/>
			)
		})
	}

	// if (isFiltered) {
	// 	return (
	// 		<>
	// 			<div className={classes.filteredItemRoot}>
	// 				{checkbox(checkboxId)}
	// 				{label}
	// 			</div>
	// 			{
	// 				children.length > 0 &&
	// 				<div className={classes.margin}>
	// 					{renderChildren()}
	// 				</div>
	// 			}
	// 		</>
	// 	)
	// }

	const onChange = (e) => {
		if(!multiple && e.target.checked)
			handleSave();
	}

	return (
		<>
			<Checkbox
				id={checkboxId}
				formikProps={formikProps}
				className={clsx(
					classes.radioGroup,
					className
				)}
				labelClassName={classes.radioGroup}
				onChange={onChange}
				label={
					<GridBlock
						justify='space-between'
						alignItems='center'
						className={classes.root}
						wrap='nowrap'
					>
						{label}
						{
							children.length > 0 &&
							<WorkableIconExpandButton
								name='button'
								onClick={handleArrowClick}
								expanded={openRow}
							/>
						}
					</GridBlock>
				}
			/>

			{
				children.length > 0 &&
				<div className={classes.margin}>
					<Collapse in={openRow}>
						{openRow ? renderChildren() : ''}
					</Collapse>
				</div>
			}
		</>

	)
}

ListElement.propTypes = {
	classes: PropTypes.any,
}

export default withStyles(style)(ListElement);